import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'

// Modules
import app from './modules/app'
import migratedPlan from './modules/migratedPlan'
import trainSchedule from './modules/trainSchedule'
import trainChange from './modules/trainChange'
import timetable from './modules/timetable'
import routeLinks from './modules/routeLinks'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [pathify.plugin],
  modules: {
    app,
    migratedPlan,
    trainSchedule,
    timetable,
    trainChange,
    routeLinks
  }
})
